import { Outlet } from 'react-router-dom'

export default function PrescriptionsPage() {
  return <Outlet />
}
